<script setup>
import { ref } from 'vue'
const emit = defineEmits(['closeTutorial'])

const currentStep = ref(1)
const totalSteps = 3

const tutorialContent = {
  1: {
    heading: "Alistar:",
    subheading: "Hello fellow muso,",
    text: [
      "Answer trivia questions by selecting",
      "1 of 3 answer options before the",
      "20 second timer runs out."
    ]
  },
  2: {
    heading: "Alistar: ",
    subheading: "Show off your music smarts,",
    text: [
      "Each question is worth 10 coins. ",
      "Answer 7,  20 second questions for",
      "a chance to WIN prizes."
    ]
  },
  3: {
    heading: "Alistar: ",
    subheading: "Let's groove to victory",
    text: [
      "Keep answering music trivia to ",
      "earn coins & climb the leaderboard."
    ]
  }
}

const nextStep = () => {
  if (currentStep.value < totalSteps) {
    currentStep.value++
  } else {
    emit('closeTutorial')
  }
}

const skipTutorial = () => {
  emit('closeTutorial')
}

const closeTutorial = () => {
 // localStorage.setItem('tutorialCompleted', 'true')
  emit('closeTutorial')
}

</script>

<template>
  <div class="tutorialOverlay">
    <div class="blurredBackground"></div>

    <div class="tutorialContent">
      <div class="col-12 tutorialImg">
        <img src="@/assets/tutorial/tutorial-img.png" alt="tutorial" class="col-9"/>
      </div>

      <div class="d-flex flex-column justify-content-center speechBubble col-8 border">
        <div class="pad">
          <div class="heading">{{ tutorialContent[currentStep].heading }}</div>
          <div class="subheading">{{ tutorialContent[currentStep].subheading }}</div>
          <div
              v-for="(line, index) in tutorialContent[currentStep].text"
              :key="index"
              class="normalText"
          >
            {{ line }}
          </div>
        </div>

        <div class="d-flex flex-row border justify-content-center gap-2 p-1 col-12">
          <div class="skip border p-1 col-5" @click="skipTutorial">SKIP TUTORIAL</div>
          <div class="next border yellowButton text-center p-1 col-5" @click="nextStep">
            {{ currentStep === totalSteps ? 'FINISH' : 'NEXT' }}
          </div>
        </div>
        <div class="text-center">{{ currentStep }}/{{ totalSteps }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tutorialOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.blurredBackground {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000015B2;
  backdrop-filter: blur(7.65px);
  -webkit-backdrop-filter: blur(7.65px);
  z-index: 4;
  background-size: cover;
}

.tutorialContent {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 5;
}

.tutorialImg {
  position: absolute;
  bottom: 0;
  left: 0;
}

.heading{
  font-weight: 700;
  font-size: 18px;
  color: #000F56;
}

.subheading{
  font-weight: 600;
  font-size: 14px;
  color: #000F56;
}

.normalText{
  font-weight: 400;
  font-size: 14px;
  color: #000F56;
}

.next{
  font-weight: 600;
  font-size: 15px;
  color:#000000;
  cursor: pointer;
}

.yellowButton{
  background-color: #FFCB05;
  border-radius: 28px;
}

.skip{
  font-weight: 700;
  font-size: 12px;
  text-decoration: underline;
  color: #2B3771;
  cursor: pointer;
}

.speechBubble{
  position: absolute;
  bottom: 2%;
  right: 10%;
  background-color: #FFFFFFD9;
  border-radius: 10px;
  border-color: #4A5488;
  border-style: solid;
}

.pad{
  padding-left: 5%;
  padding-top: 5%;
}
</style>